module.exports = __webpack_public_path__ + "img/1.ea6905ec.jpg";